import { render, staticRenderFns } from "./PublicBatches.vue?vue&type=template&id=258b0be7&scoped=true"
import script from "./PublicBatches.vue?vue&type=script&lang=js"
export * from "./PublicBatches.vue?vue&type=script&lang=js"
import style0 from "./PublicBatches.vue?vue&type=style&index=0&id=258b0be7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b0be7",
  null
  
)

export default component.exports